export enum ChangeStrategyStatusWizardActions {
  OpenArchiveStrategyWizard = 'archiveStrategyWizard/openWizard',
  CloseArchiveStrategyWizard = 'archiveStrategyWizard/closeWizard',
}
